import { UserDefinedFieldViewModel } from "@tylertech/tyler-api-types";

export interface Activatable
{
    /**
     * NOTE: not set from server; used for display
     */
    Active?: boolean;
}

/**
 * Pulled from backend source.
 * @see Incode10/Foundation/Common.Model/TypeDefinitions/UserDefinedControlType.cs
 */
export type UserDefinedDataType = "Check" | "Date" | "Number" | "Single Value" | "Text" | "Select" | "MultiSelect" /* | "Multiple Values" */;

export interface UserDefinedField<T extends UserDefinedDataType = "Text"> extends UserDefinedFieldViewModel, Activatable
{
    /* overrides */ DataType: T;
}

export function isUserDefinedTextField(x: UserDefinedFieldViewModel): x is UserDefinedField<"Text">
{
    return x.DataType === "Text";
}

export function isUserDefinedNumberField(x: UserDefinedFieldViewModel): x is UserDefinedField<"Number">
{
    return x.DataType === "Number";
}

export function isUserDefinedCheckboxField(x: UserDefinedFieldViewModel): x is UserDefinedField<"Check">
{
    return x.DataType === "Check";
}

export function isUserDefinedDateField(x: UserDefinedFieldViewModel): x is UserDefinedField<"Date">
{
    return x.DataType === "Date";
}

export function isUserDefinedSelectField(x: UserDefinedFieldViewModel): x is UserDefinedField<"Select">
{
    return x.DataType === "Select";
}

export function isUserDefinedMultiSelectField(x: UserDefinedFieldViewModel): x is UserDefinedField<"MultiSelect">
{
    return x.DataType === "MultiSelect";
}

